/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get_inline_address } from "../../utils/data";
import { formatTime, STATUS_COLOR } from "../utils";
import { eventBus } from "../eventBus";

import StatusPill from "../../shared/components/StatusPill.vue";
import ItemTable from "./ItemTable.vue";
import SignatureField from "./SignatureField.vue";

const __vue_script__ = {
  name: "StopList",
  components: { StatusPill, ItemTable, SignatureField },
  props: ["stop", "reasons"],
  emits: ["back", "save"],
  data() {
    return {
      proofs: [],
      signing: false,
      signature: "",
      pendingChanges: [],
      statusColor: STATUS_COLOR,
    };
  },
  mounted() {
    this.signature = this.stop.signature;
    this.proofs = this.stop.proofs || [];
  },
  computed: {
    noContactPhone() {
      return !this.stop.contact_phone || this.stop.contact_phone.length === 0;
    },
    hasDO() {
      return (
        this.stop.document === "Inventory Movement Validation" &&
        this.stop.delivery_note
      );
    },
    doctype() {
      if (this.hasDO) {
        return "Delivery Note";
      }
      return this.stop.document;
    },
    docname() {
      if (this.hasDO) {
        return this.stop.delivery_note;
      }
      return this.stop.document_name;
    },
    remarksReqd() {
      return this.doctype == "Delivery Note"
    }
  },
  methods: {
    formatTime: formatTime,
    formatAddress(address) {
      return get_inline_address(address);
    },
    onItemChange(change) {
      this.appendChanges("item", change);
    },
    attachImage(event) {
      const file = event.target.files[0];
      if (file) {
        this.proofs = [...this.proofs, file];
      }
    },
    onRemoveProof(index) {
      this.proofs.splice(index, 1);
    },
    appendChanges(doc, { name, field, value }) {
      const exists = this.pendingChanges.find(
        (c) => c.doc === doc && c.name === name && c.field === field
      );

      if (exists) {
        exists.value = value;
      } else {
        this.pendingChanges.push({ doc, name, field, value });
      }
    },
    onSign(dataUri) {
      this.signature = dataUri;
      this.appendChanges("stop", {
        name: this.stop.name,
        field: "signature",
        value: dataUri,
      });
    },
    onBack() {
      frappe.confirm(
        "Your data will <strong>not be saved</strong>. Are you sure you want to go back?",
        () => {
          this.$emit("back");
        }
      );
    },
    onSave() {
      frappe.freeze("Updating...");

      const formData = new FormData();
      formData.append("stop", this.stop.name);
      formData.append("changes", JSON.stringify(this.pendingChanges));
      this.proofs.map((f) => {
        formData.append(f.name, f);
      });
      fetch(
        "/api/method/mesrajaya.mesrajaya.doctype.planned_delivery_trip.planned_delivery_trip.update_stop",
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Frappe-CSRF-Token": frappe.csrf_token,
          },
        }
      )
        .then((res) => res.json())
        .then((response) => {
          if (!response.success) {
            throw new Error(response.exception);
          }
          this.pendingChanges = [];
          this.proofs = [];
          eventBus.$emit("load-doc");
          this.$emit("save");
        })
        .catch((error) => {
          console.error(error);
          frappe.throw("Something went wrong. Please try again later.");
        })
        .finally(() => {
          frappe.unfreeze();
        });
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-3" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-wrap w-100 justify-content-between align-items-center mt-3"
      },
      [
        _c("label", [
          _c("small", [_vm._v(_vm._s(_vm.doctype))]),
          _vm._v(" "),
          _c("h5", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.docname))])
        ]),
        _vm._v(" "),
        _c("status-pill", {
          attrs: {
            colors: _vm.statusColor,
            status: _vm.stop.status,
            doctype: _vm.stop.doctype
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col" }, [
        _c("span", { staticClass: "indicator-pill whitespace-nowrap blue" }, [
          _c("span", [_vm._v(_vm._s(_vm.stop.type))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("label", [
          _c("small", [_vm._v("Contact Person")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.stop.contact_fullname || "-") +
                "\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("label", [
          _c("small", [_vm._v("Contact Phone No.")]),
          _vm._v(" "),
          _c(
            "p",
            [
              _vm._l(_vm.stop.contact_phone, function(phone) {
                return _c("span", { key: phone, staticClass: "d-block" }, [
                  _vm._v("\n            " + _vm._s(phone) + "\n          ")
                ])
              }),
              _vm._v(" "),
              _vm.noContactPhone ? _c("span", [_vm._v("-")]) : _vm._e()
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.stop.google_map_link
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("label", [
              _c("small", [_vm._v("Google Map")]),
              _vm._v(" "),
              _c("p", [
                _c(
                  "a",
                  {
                    attrs: { href: _vm.stop.google_map_link, target: "_blank" }
                  },
                  [_vm._v("\n            Open in Google Map\n          ")]
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("label", [
          _c("small", [_vm._v("Address")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v(_vm._s(_vm.stop.party))]),
            _vm._v(" "),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.stop.address_display) }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.stop.has_transit_point
      ? _c("div", { staticClass: "border-top mt-3 py-3" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("label", [
                _c("small", [_vm._v("Transit Name")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.stop.transit_name) +
                      "\n          "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _c("label", [
                _c("small", [_vm._v("Driver")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.stop.driver) + "\n          "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("label", [
                _c("small", [_vm._v("Contact Number")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.stop.contact_number) +
                      "\n          "
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "border-top mt-3 py-3" },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("item-table", {
          attrs: {
            items: _vm.stop.stop_items,
            reasons: _vm.reasons,
            remarksReqd: _vm.remarksReqd
          },
          on: { "item-change": _vm.onItemChange }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "border-top mt-3 py-3" },
      [
        _vm._m(2),
        _vm._v(" "),
        _c("label", [
          _c("small", [_vm._v("Proofs")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn ml-3",
              on: {
                click: function($event) {
                  return _vm.$refs.proof_field.click()
                }
              }
            },
            [_vm._v("\n        Choose File\n      ")]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "proof_field",
            staticClass: "hide",
            attrs: { type: "file", accept: "image/*" },
            on: {
              change: function($event) {
                return _vm.attachImage($event)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "existing-proof",
          domProps: { innerHTML: _vm._s(_vm.stop.proof_display) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list-group" },
          _vm._l(_vm.proofs, function(file, index) {
            return _c(
              "div",
              {
                key: file.name,
                staticClass:
                  "list-group-item d-flex justify-content-between align-items-center"
              },
              [
                _c("p", { staticClass: "text-truncate w-80" }, [
                  _vm._v(_vm._s(file.name))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-icon btn-danger",
                    on: {
                      click: function($event) {
                        return _vm.onRemoveProof(index)
                      }
                    }
                  },
                  [_vm._v("\n          X\n        ")]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("signature-field", {
          staticClass: "mx-auto mt-3",
          attrs: { value: _vm.signature, editing: _vm.signing },
          on: { input: _vm.onSign }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-center mt-2" }, [
          _vm.signing
            ? _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.signing = false
                    }
                  }
                },
                [_vm._v("\n        Preview\n      ")]
              )
            : _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.signing = true
                    }
                  }
                },
                [_vm._v("Sign")]
              )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "border-top mt-3 py-3" }, [
      _c(
        "div",
        { staticClass: "d-flex flex-wrap w-100 mt-3 justify-content-between" },
        [
          _c(
            "button",
            { staticClass: "btn btn-secondary", on: { click: _vm.onBack } },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.onSave } },
            [_vm._v("Mark as Visited")]
          )
        ]
      )
    ])
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Transit Point")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Items")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Visited Details")])])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a29e474c_0", { source: "\nlabel > small[data-v-a29e474c] {\n  font-weight: bold;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/StopDetail.vue"],"names":[],"mappings":";AAsTA;EACA,iBAAA;AACA","file":"StopDetail.vue","sourcesContent":["<template>\n  <div class=\"py-3\">\n    <div\n      class=\"d-flex flex-wrap w-100 justify-content-between align-items-center mt-3\"\n    >\n      <label>\n        <small>{{ doctype }}</small>\n        <h5 class=\"mb-1\">{{ docname }}</h5>\n      </label>\n      <status-pill\n        :colors=\"statusColor\"\n        :status=\"stop.status\"\n        :doctype=\"stop.doctype\"\n      />\n    </div>\n\n    <div class=\"row mb-3\">\n      <div class=\"col\">\n        <span class=\"indicator-pill whitespace-nowrap blue\">\n          <span>{{ stop.type }}</span>\n        </span>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col\">\n        <label>\n          <small>Contact Person</small>\n          <p>\n            {{ stop.contact_fullname || \"-\" }}\n          </p>\n        </label>\n      </div>\n      <div class=\"col\">\n        <label>\n          <small>Contact Phone No.</small>\n          <p>\n            <span\n              class=\"d-block\"\n              v-for=\"phone in stop.contact_phone\"\n              :key=\"phone\"\n            >\n              {{ phone }}\n            </span>\n            <span v-if=\"noContactPhone\">-</span>\n          </p>\n        </label>\n      </div>\n    </div>\n    <div class=\"row\" v-if=\"stop.google_map_link\">\n      <div class=\"col\">\n        <label>\n          <small>Google Map</small>\n          <p>\n            <a :href=\"stop.google_map_link\" target=\"_blank\">\n              Open in Google Map\n            </a>\n          </p>\n        </label>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col\">\n        <label>\n          <small>Address</small>\n          <p>\n            <strong>{{ stop.party }}</strong>\n            <span v-html=\"stop.address_display\"> </span>\n          </p>\n        </label>\n      </div>\n    </div>\n\n    <div v-if=\"stop.has_transit_point\" class=\"border-top mt-3 py-3\">\n      <p><strong>Transit Point</strong></p>\n      <div class=\"row\">\n        <div class=\"col\">\n          <label>\n            <small>Transit Name</small>\n            <p>\n              {{ stop.transit_name }}\n            </p>\n          </label>\n        </div>\n        <div class=\"col\">\n          <label>\n            <small>Driver</small>\n            <p>\n              {{ stop.driver }}\n            </p>\n          </label>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col\">\n          <label>\n            <small>Contact Number</small>\n            <p>\n              {{ stop.contact_number }}\n            </p>\n          </label>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"border-top mt-3 py-3\">\n      <p><strong>Items</strong></p>\n      <item-table\n        :items=\"stop.stop_items\"\n        :reasons=\"reasons\"\n        :remarksReqd=\"remarksReqd\"\n        @item-change=\"onItemChange\"\n      />\n    </div>\n\n    <div class=\"border-top mt-3 py-3\">\n      <p><strong>Visited Details</strong></p>\n\n      <label>\n        <small>Proofs</small>\n        <button class=\"btn ml-3\" @click=\"$refs.proof_field.click()\">\n          Choose File\n        </button>\n        <input\n          ref=\"proof_field\"\n          class=\"hide\"\n          type=\"file\"\n          accept=\"image/*\"\n          @change=\"attachImage($event)\"\n        />\n      </label>\n      <div class=\"existing-proof\" v-html=\"stop.proof_display\"></div>\n      <div class=\"list-group\">\n        <div\n          class=\"list-group-item d-flex justify-content-between align-items-center\"\n          v-for=\"(file, index) in proofs\"\n          :key=\"file.name\"\n        >\n          <p class=\"text-truncate w-80\">{{ file.name }}</p>\n          <button\n            class=\"btn btn-sm btn-icon btn-danger\"\n            @click=\"onRemoveProof(index)\"\n          >\n            X\n          </button>\n        </div>\n      </div>\n\n      <signature-field\n        class=\"mx-auto mt-3\"\n        :value=\"signature\"\n        @input=\"onSign\"\n        :editing=\"signing\"\n      />\n      <div class=\"text-center mt-2\">\n        <button class=\"btn\" @click=\"signing = false\" v-if=\"signing\">\n          Preview\n        </button>\n        <button class=\"btn\" @click=\"signing = true\" v-else>Sign</button>\n      </div>\n    </div>\n\n    <div class=\"border-top mt-3 py-3\">\n      <div class=\"d-flex flex-wrap w-100 mt-3 justify-content-between\">\n        <button class=\"btn btn-secondary\" @click=\"onBack\">Back</button>\n        <button class=\"btn btn-primary\" @click=\"onSave\">Mark as Visited</button>\n      </div>\n    </div>\n  </div>\n</template>\n<script>\nimport { get_inline_address } from \"../../utils/data\";\nimport { formatTime, STATUS_COLOR } from \"../utils\";\nimport { eventBus } from \"../eventBus\";\n\nimport StatusPill from \"../../shared/components/StatusPill.vue\";\nimport ItemTable from \"./ItemTable.vue\";\nimport SignatureField from \"./SignatureField.vue\";\n\nexport default {\n  name: \"StopList\",\n  components: { StatusPill, ItemTable, SignatureField },\n  props: [\"stop\", \"reasons\"],\n  emits: [\"back\", \"save\"],\n  data() {\n    return {\n      proofs: [],\n      signing: false,\n      signature: \"\",\n      pendingChanges: [],\n      statusColor: STATUS_COLOR,\n    };\n  },\n  mounted() {\n    this.signature = this.stop.signature;\n    this.proofs = this.stop.proofs || [];\n  },\n  computed: {\n    noContactPhone() {\n      return !this.stop.contact_phone || this.stop.contact_phone.length === 0;\n    },\n    hasDO() {\n      return (\n        this.stop.document === \"Inventory Movement Validation\" &&\n        this.stop.delivery_note\n      );\n    },\n    doctype() {\n      if (this.hasDO) {\n        return \"Delivery Note\";\n      }\n      return this.stop.document;\n    },\n    docname() {\n      if (this.hasDO) {\n        return this.stop.delivery_note;\n      }\n      return this.stop.document_name;\n    },\n    remarksReqd() {\n      return this.doctype == \"Delivery Note\"\n    }\n  },\n  methods: {\n    formatTime: formatTime,\n    formatAddress(address) {\n      return get_inline_address(address);\n    },\n    onItemChange(change) {\n      this.appendChanges(\"item\", change);\n    },\n    attachImage(event) {\n      const file = event.target.files[0];\n      if (file) {\n        this.proofs = [...this.proofs, file];\n      }\n    },\n    onRemoveProof(index) {\n      this.proofs.splice(index, 1);\n    },\n    appendChanges(doc, { name, field, value }) {\n      const exists = this.pendingChanges.find(\n        (c) => c.doc === doc && c.name === name && c.field === field\n      );\n\n      if (exists) {\n        exists.value = value;\n      } else {\n        this.pendingChanges.push({ doc, name, field, value });\n      }\n    },\n    onSign(dataUri) {\n      this.signature = dataUri;\n      this.appendChanges(\"stop\", {\n        name: this.stop.name,\n        field: \"signature\",\n        value: dataUri,\n      });\n    },\n    onBack() {\n      frappe.confirm(\n        \"Your data will <strong>not be saved</strong>. Are you sure you want to go back?\",\n        () => {\n          this.$emit(\"back\");\n        }\n      );\n    },\n    onSave() {\n      frappe.freeze(\"Updating...\");\n\n      const formData = new FormData();\n      formData.append(\"stop\", this.stop.name);\n      formData.append(\"changes\", JSON.stringify(this.pendingChanges));\n      this.proofs.map((f) => {\n        formData.append(f.name, f);\n      });\n      fetch(\n        \"/api/method/mesrajaya.mesrajaya.doctype.planned_delivery_trip.planned_delivery_trip.update_stop\",\n        {\n          method: \"POST\",\n          body: formData,\n          headers: {\n            Accept: \"application/json\",\n            \"X-Frappe-CSRF-Token\": frappe.csrf_token,\n          },\n        }\n      )\n        .then((res) => res.json())\n        .then((response) => {\n          if (!response.success) {\n            throw new Error(response.exception);\n          }\n          this.pendingChanges = [];\n          this.proofs = [];\n          eventBus.$emit(\"load-doc\");\n          this.$emit(\"save\");\n        })\n        .catch((error) => {\n          console.error(error);\n          frappe.throw(\"Something went wrong. Please try again later.\");\n        })\n        .finally(() => {\n          frappe.unfreeze();\n        });\n    },\n  },\n};\n</script>\n\n<style scoped>\nlabel > small {\n  font-weight: bold;\n}\n</style>\n\n<style>\n#freeze.modal-backdrop.fade {\n  opacity: 0.3;\n}\n#freeze .freeze-message {\n  height: 100vh;\n  text-align: center;\n  line-height: 100vh;\n}\n</style>\n"]}, media: undefined })
,inject("data-v-a29e474c_1", { source: "\n#freeze.modal-backdrop.fade {\n  opacity: 0.3;\n}\n#freeze .freeze-message {\n  height: 100vh;\n  text-align: center;\n  line-height: 100vh;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/StopDetail.vue"],"names":[],"mappings":";AA4TA;EACA,YAAA;AACA;AACA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AACA","file":"StopDetail.vue","sourcesContent":["<template>\n  <div class=\"py-3\">\n    <div\n      class=\"d-flex flex-wrap w-100 justify-content-between align-items-center mt-3\"\n    >\n      <label>\n        <small>{{ doctype }}</small>\n        <h5 class=\"mb-1\">{{ docname }}</h5>\n      </label>\n      <status-pill\n        :colors=\"statusColor\"\n        :status=\"stop.status\"\n        :doctype=\"stop.doctype\"\n      />\n    </div>\n\n    <div class=\"row mb-3\">\n      <div class=\"col\">\n        <span class=\"indicator-pill whitespace-nowrap blue\">\n          <span>{{ stop.type }}</span>\n        </span>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col\">\n        <label>\n          <small>Contact Person</small>\n          <p>\n            {{ stop.contact_fullname || \"-\" }}\n          </p>\n        </label>\n      </div>\n      <div class=\"col\">\n        <label>\n          <small>Contact Phone No.</small>\n          <p>\n            <span\n              class=\"d-block\"\n              v-for=\"phone in stop.contact_phone\"\n              :key=\"phone\"\n            >\n              {{ phone }}\n            </span>\n            <span v-if=\"noContactPhone\">-</span>\n          </p>\n        </label>\n      </div>\n    </div>\n    <div class=\"row\" v-if=\"stop.google_map_link\">\n      <div class=\"col\">\n        <label>\n          <small>Google Map</small>\n          <p>\n            <a :href=\"stop.google_map_link\" target=\"_blank\">\n              Open in Google Map\n            </a>\n          </p>\n        </label>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col\">\n        <label>\n          <small>Address</small>\n          <p>\n            <strong>{{ stop.party }}</strong>\n            <span v-html=\"stop.address_display\"> </span>\n          </p>\n        </label>\n      </div>\n    </div>\n\n    <div v-if=\"stop.has_transit_point\" class=\"border-top mt-3 py-3\">\n      <p><strong>Transit Point</strong></p>\n      <div class=\"row\">\n        <div class=\"col\">\n          <label>\n            <small>Transit Name</small>\n            <p>\n              {{ stop.transit_name }}\n            </p>\n          </label>\n        </div>\n        <div class=\"col\">\n          <label>\n            <small>Driver</small>\n            <p>\n              {{ stop.driver }}\n            </p>\n          </label>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col\">\n          <label>\n            <small>Contact Number</small>\n            <p>\n              {{ stop.contact_number }}\n            </p>\n          </label>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"border-top mt-3 py-3\">\n      <p><strong>Items</strong></p>\n      <item-table\n        :items=\"stop.stop_items\"\n        :reasons=\"reasons\"\n        :remarksReqd=\"remarksReqd\"\n        @item-change=\"onItemChange\"\n      />\n    </div>\n\n    <div class=\"border-top mt-3 py-3\">\n      <p><strong>Visited Details</strong></p>\n\n      <label>\n        <small>Proofs</small>\n        <button class=\"btn ml-3\" @click=\"$refs.proof_field.click()\">\n          Choose File\n        </button>\n        <input\n          ref=\"proof_field\"\n          class=\"hide\"\n          type=\"file\"\n          accept=\"image/*\"\n          @change=\"attachImage($event)\"\n        />\n      </label>\n      <div class=\"existing-proof\" v-html=\"stop.proof_display\"></div>\n      <div class=\"list-group\">\n        <div\n          class=\"list-group-item d-flex justify-content-between align-items-center\"\n          v-for=\"(file, index) in proofs\"\n          :key=\"file.name\"\n        >\n          <p class=\"text-truncate w-80\">{{ file.name }}</p>\n          <button\n            class=\"btn btn-sm btn-icon btn-danger\"\n            @click=\"onRemoveProof(index)\"\n          >\n            X\n          </button>\n        </div>\n      </div>\n\n      <signature-field\n        class=\"mx-auto mt-3\"\n        :value=\"signature\"\n        @input=\"onSign\"\n        :editing=\"signing\"\n      />\n      <div class=\"text-center mt-2\">\n        <button class=\"btn\" @click=\"signing = false\" v-if=\"signing\">\n          Preview\n        </button>\n        <button class=\"btn\" @click=\"signing = true\" v-else>Sign</button>\n      </div>\n    </div>\n\n    <div class=\"border-top mt-3 py-3\">\n      <div class=\"d-flex flex-wrap w-100 mt-3 justify-content-between\">\n        <button class=\"btn btn-secondary\" @click=\"onBack\">Back</button>\n        <button class=\"btn btn-primary\" @click=\"onSave\">Mark as Visited</button>\n      </div>\n    </div>\n  </div>\n</template>\n<script>\nimport { get_inline_address } from \"../../utils/data\";\nimport { formatTime, STATUS_COLOR } from \"../utils\";\nimport { eventBus } from \"../eventBus\";\n\nimport StatusPill from \"../../shared/components/StatusPill.vue\";\nimport ItemTable from \"./ItemTable.vue\";\nimport SignatureField from \"./SignatureField.vue\";\n\nexport default {\n  name: \"StopList\",\n  components: { StatusPill, ItemTable, SignatureField },\n  props: [\"stop\", \"reasons\"],\n  emits: [\"back\", \"save\"],\n  data() {\n    return {\n      proofs: [],\n      signing: false,\n      signature: \"\",\n      pendingChanges: [],\n      statusColor: STATUS_COLOR,\n    };\n  },\n  mounted() {\n    this.signature = this.stop.signature;\n    this.proofs = this.stop.proofs || [];\n  },\n  computed: {\n    noContactPhone() {\n      return !this.stop.contact_phone || this.stop.contact_phone.length === 0;\n    },\n    hasDO() {\n      return (\n        this.stop.document === \"Inventory Movement Validation\" &&\n        this.stop.delivery_note\n      );\n    },\n    doctype() {\n      if (this.hasDO) {\n        return \"Delivery Note\";\n      }\n      return this.stop.document;\n    },\n    docname() {\n      if (this.hasDO) {\n        return this.stop.delivery_note;\n      }\n      return this.stop.document_name;\n    },\n    remarksReqd() {\n      return this.doctype == \"Delivery Note\"\n    }\n  },\n  methods: {\n    formatTime: formatTime,\n    formatAddress(address) {\n      return get_inline_address(address);\n    },\n    onItemChange(change) {\n      this.appendChanges(\"item\", change);\n    },\n    attachImage(event) {\n      const file = event.target.files[0];\n      if (file) {\n        this.proofs = [...this.proofs, file];\n      }\n    },\n    onRemoveProof(index) {\n      this.proofs.splice(index, 1);\n    },\n    appendChanges(doc, { name, field, value }) {\n      const exists = this.pendingChanges.find(\n        (c) => c.doc === doc && c.name === name && c.field === field\n      );\n\n      if (exists) {\n        exists.value = value;\n      } else {\n        this.pendingChanges.push({ doc, name, field, value });\n      }\n    },\n    onSign(dataUri) {\n      this.signature = dataUri;\n      this.appendChanges(\"stop\", {\n        name: this.stop.name,\n        field: \"signature\",\n        value: dataUri,\n      });\n    },\n    onBack() {\n      frappe.confirm(\n        \"Your data will <strong>not be saved</strong>. Are you sure you want to go back?\",\n        () => {\n          this.$emit(\"back\");\n        }\n      );\n    },\n    onSave() {\n      frappe.freeze(\"Updating...\");\n\n      const formData = new FormData();\n      formData.append(\"stop\", this.stop.name);\n      formData.append(\"changes\", JSON.stringify(this.pendingChanges));\n      this.proofs.map((f) => {\n        formData.append(f.name, f);\n      });\n      fetch(\n        \"/api/method/mesrajaya.mesrajaya.doctype.planned_delivery_trip.planned_delivery_trip.update_stop\",\n        {\n          method: \"POST\",\n          body: formData,\n          headers: {\n            Accept: \"application/json\",\n            \"X-Frappe-CSRF-Token\": frappe.csrf_token,\n          },\n        }\n      )\n        .then((res) => res.json())\n        .then((response) => {\n          if (!response.success) {\n            throw new Error(response.exception);\n          }\n          this.pendingChanges = [];\n          this.proofs = [];\n          eventBus.$emit(\"load-doc\");\n          this.$emit(\"save\");\n        })\n        .catch((error) => {\n          console.error(error);\n          frappe.throw(\"Something went wrong. Please try again later.\");\n        })\n        .finally(() => {\n          frappe.unfreeze();\n        });\n    },\n  },\n};\n</script>\n\n<style scoped>\nlabel > small {\n  font-weight: bold;\n}\n</style>\n\n<style>\n#freeze.modal-backdrop.fade {\n  opacity: 0.3;\n}\n#freeze .freeze-message {\n  height: 100vh;\n  text-align: center;\n  line-height: 100vh;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-a29e474c"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/StopDetail.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__